import React, { Fragment } from "react";
import ReactDOM from "react-dom/client";
import { Auth0Provider } from "@auth0/auth0-react";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import { Provider } from "react-redux";
import store from "./store";
import settings from "./constants/settings";
import * as Sentry from "@sentry/react";
import { Environments } from "./constants/enums";

// HOTFIX TEMPORAL: Sentry deshabilitado mientras se investiga el 429
const SENTRY_ENABLED = false;

if (
  SENTRY_ENABLED &&
  (settings.sentry.environment === Environments.STAGING ||
    settings.sentry.environment === Environments.PRODUCTION)
) {
  Sentry.init({
    dsn: "https://e2d1874534c0474429b1410d647465d9@o4508960395952128.ingest.us.sentry.io/4508967414202368",
    sendDefaultPii: true,
    environment: settings.sentry.environment,
    release: settings.packageVersion,
  });

  Sentry.setTag("platform", "rombo-frontend");
  Sentry.setTag("environment", settings.sentry.environment);
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <Fragment>
    <Provider store={store}>
      <BrowserRouter>
        <Auth0Provider
          domain={`${settings.auth0.domain}`}
          clientId={settings.auth0.clientId}
          cacheLocation="localstorage"
          useRefreshTokens={true}
          useRefreshTokensFallback={true}
          authorizationParams={{
            scope: "read:current_user offline_access",
            audience: settings.auth0.audience,
            redirect_uri: window.location.origin,
          }}
          onRedirectCallback={(appState) => {
            const target = appState?.returnTo || window.location.pathname + window.location.search;
            window.history.replaceState({}, '', target);
          }}
        >
          <App />
        </Auth0Provider>
      </BrowserRouter>
    </Provider>
  </Fragment>
);

serviceWorker.unregister();
